import * as Yup from 'yup'

import { type RegisterFormValues } from './RegisterForm.type'
import { usePhoneNumberValidator } from '../../Form/fields/PhoneNumberField/validator'

const useValidationSchema = () => {
  const validatePhoneNumber = usePhoneNumberValidator()

  return Yup.object<RegisterFormValues>().shape({
    firstName: Yup.string().required(),
    lastName: Yup.string().required(),
    email: Yup.string().email().required(),
    phoneNumber: validatePhoneNumber({ required: true }),
  }) as Yup.ObjectSchema<RegisterFormValues, RegisterFormValues>
}

export default useValidationSchema
